import { SetPasswordForm } from "@/features/auth/components/set-password-form";

export default function SetPasswordPage() {
  return <SetPasswordForm />;
}
